import {fetch} from 'whatwg-fetch';
import queryString from 'query-string';

class Oauth2Service {
  constructor() {
    // eslint-disable-next-line
    this.apiUrl = process.env.TBX_API_URL || (window.AppENV && window.AppENV.API_URL);
  }

  authorize = async (config, data) => {
    const queryParams = {
      client_id: config.client_id,
      redirect_uri: config.redirect_uri,
      state: config.state,
      response_type: 'code',
    };

    const result = await fetch(`${this.apiUrl}/oauth2/authorize?${queryString.stringify(queryParams)}`, {
      method: 'POST',
      body: JSON.stringify({
        msisdn: data.msisdn,
        pin: data.pin,
        grant_type: 'pin'
      }),
      headers: {
        'Content-Type': 'application/json'
      }
    }).then((res) => res.json());

    return result;
  }

  sendPin = async (msisdn, client, recaptcha) => {
    const result = await fetch(`${this.apiUrl}/bitel/pin`, {
      method: 'POST',
      body: JSON.stringify({
        client,
        phone: msisdn,
        'g-recaptcha-response': recaptcha
      }),
      headers: {
        'Content-Type': 'application/json'
      }
    }).then((res) => res.json());

    return result;
  }

  register = async (msisdn, plan, config, recaptcha) => {
    const queryParams = {
      client_id: config.client_id,
      redirect_uri: config.redirect_uri,
      state: config.state,
      response_type: 'code',
      plan
    };

    const result = await fetch(`${this.apiUrl}/bitel/register?${queryString.stringify(queryParams)}`, {
      method: 'POST',
      body: JSON.stringify({
        msisdn,
        grant_type: 'register',
        'g-recaptcha-response': recaptcha
      }),
      headers: {
        'Content-Type': 'application/json'
      }
    }).then((res) => res.json());

    return result;
  }

  verifyAccess = async (msisdn, client) => {
    const result = await fetch(`${this.apiUrl}/bitel/verifyAccess/${msisdn}/${client}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json'
      }
    }).then((res) => res.json());

    return result;
  }

}

export default new Oauth2Service();
